// Next Diamonds - PDP Video Click Toggle (v8)
//
// Problem v7 had: when Symmetry re-renders the media on variant change, it
// puts back the .show-gallery class and href on the wrapper anchor, and my
// per-tile bindings did not re-disarm it (already-bound dataset flag).
//
// v8 strategy: stateless. Document-level capture-phase click handler that
// fires on every click, anywhere. If the click landed on a video tile, we
// preventDefault and toggle. A MutationObserver re-disarms .show-gallery on
// every DOM change, so Symmetry cannot re-arm the lightbox behind us.

console.log('[ND video toggle v8] script loaded');

(function () {
  'use strict';

  var TILE = '.product-media-collage__item, .slider__item';

  function isVideoTile(tile) {
    if (!tile) return false;
    if (tile.classList.contains('media-type-video')) return true;
    return !!tile.querySelector('deferred-media[data-video-type], video');
  }

  function disarmAll() {
    document.querySelectorAll(TILE).forEach(function (tile) {
      if (!isVideoTile(tile)) return;
      tile.style.cursor = 'pointer';
      var link = tile.querySelector('a.show-gallery, a[href*="cdn/shop"]');
      if (link) {
        link.classList.remove('show-gallery');
        link.removeAttribute('href');
      }
    });
  }

  function findOrLoadVideo(tile, cb) {
    var v = tile.querySelector('video');
    if (v) return cb(v);
    var dm = tile.querySelector('deferred-media');
    if (dm && typeof dm.loadContent === 'function') {
      try { dm.loadContent(false, false, 'click'); } catch (_) {}
    }
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      var v2 = tile.querySelector('video');
      if (v2) { clearInterval(iv); cb(v2); return; }
      if (attempts > 40) clearInterval(iv);
    }, 50);
  }

  function toggleVideo(v) {
    if (!v || typeof v.play !== 'function') return;
    if (v.paused) {
      if (v.muted) v.muted = false;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } else {
      v.pause();
    }
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.tagName === 'BUTTON' || t.closest('button')) return;
    var tile = t.closest(TILE);
    if (!tile || !isVideoTile(tile)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    findOrLoadVideo(tile, function (v) {
      if (v.readyState === 0) {
        v.addEventListener('loadedmetadata', function once() {
          v.removeEventListener('loadedmetadata', once);
          toggleVideo(v);
        });
      } else {
        toggleVideo(v);
      }
    });
  }

  function init() {
    disarmAll();
    document.addEventListener('click', onClick, true);
    var mo = new MutationObserver(disarmAll);
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
